import { gql, DocumentNode } from '@apollo/client';
import { Box } from '@mui/material';
import React from 'react';
import { InvoiceViewLineItemSummary } from './InvoiceViewLineItemSummary';
import { InvoiceViewNotes } from './InvoiceViewNotes/InvoiceViewNotes';
import styles from './InvoiceViewNotesAndLineItemSummary.module.scss';
import { InvoiceViewNotesAndLineItemSummaryInvoiceFragment } from '#types';
import { InvoiceAttachment } from './InvoiceAttachment';
import classNames from 'classnames';

export const invoiceViewNotesAndLineItemSummaryInvoiceFragment = gql`
	fragment invoiceViewNotesAndLineItemSummaryInvoice on Invoice {
		...invoiceViewNotesInvoice
		...invoiceViewLineItemSummaryInvoice
		...invoiceAttachmentInvoice
	}
	${ InvoiceViewNotes.fragments.invoiceViewNotesInvoiceFragment }
	${ InvoiceViewLineItemSummary.fragments
		.invoiceViewLineItemSummaryInvoiceFragment }
	${ InvoiceAttachment.fragments.invoiceAttachmentInvoiceFragment }
`;

export type InvoiceViewNotesAndLineItemSummaryProps = {
	invoice?: InvoiceViewNotesAndLineItemSummaryInvoiceFragment;
	fileOrFilename?: File | string | undefined;
	guestToken?: string;
};

type InvoiceViewNotesAndLineItemSummaryPropsWithFragment =
	React.FC<InvoiceViewNotesAndLineItemSummaryProps> & {
		fragments: {
			invoiceViewNotesAndLineItemSummaryInvoiceFragment: DocumentNode;
		};
	};

export const InvoiceViewNotesAndLineItemSummary: InvoiceViewNotesAndLineItemSummaryPropsWithFragment =
	( { invoice, fileOrFilename, guestToken } ) => (
		<Box
			className={ classNames(
				styles.container,
				{ [ styles.withNotes ]: !!invoice?.notes },
				{
					[ styles.withAttachment ]:
						!!invoice?.uploadAttachment || !!fileOrFilename,
				}
			) }
		>
			<InvoiceViewNotes className={ styles.notes } invoice={ invoice } />
			<InvoiceAttachment
				className={ styles.attachment }
				invoice={ invoice }
				guestToken={ guestToken }
				fileOrFilename={ fileOrFilename }
			/>
			<InvoiceViewLineItemSummary
				className={ styles.lineItemSummary }
				invoice={ invoice }
			/>
		</Box>
	);

InvoiceViewNotesAndLineItemSummary.fragments = {
	invoiceViewNotesAndLineItemSummaryInvoiceFragment,
};
